// From packages/app-front/.env. Tests replace this file (jest.config.mjs):
// Jest can't read import.meta.
export const CLERK_PUBLISHABLE_KEY: string | undefined = import.meta.env
  .VITE_CLERK_PUBLISHABLE_KEY;
